import {defineMessages} from 'react-intl';

const FooterLinkMessages = defineMessages({
  'about-us': {
    id: 'Footer.link.about-us',
    defaultMessage: 'About Us',
  },
  help: {
    id: 'Footer.link.cs',
    defaultMessage: 'Help Center',
  },
  developers: {
    id: 'Footer.link.developers',
    defaultMessage: 'For Developers',
  },
  'contact-us': {
    id: 'Footer.link.contact-us',
    defaultMessage: 'Contact Us',
  },
  careers: {
    id: 'Footer.link.careers',
    defaultMessage: 'Careers',
  },
  legal: {
    id: 'Footer.link.legal',
    defaultMessage: 'Terms, Privacy & Cookies',
  },
  partners: {
    id: 'Footer.link.partners',
    defaultMessage: 'Partners',
  },
  advantage: {
    id: 'Footer.link.advantage',
    defaultMessage: 'The StubHub Promise',
  },
  notifications: {
    id: 'Footer.link.notifications',
    defaultMessage: 'Notifications',
  },
  'events-by-venue': {
    id: 'Footer.link.events-by-venue',
    defaultMessage: 'Top Cities',
  },
  affiliates: {
    id: 'Footer.link.affiliates',
    defaultMessage: 'Affiliates',
  },
  impressum: {
    id: 'Footer.link.impressum',
    defaultMessage: 'Impressum',
  },
  restrictions: {
    id: 'Footer.link.restrictions',
    defaultMessage: 'Restrictions',
  },
  'ethics-compliance': {
    id: 'Footer.link.ethics-compliance',
    defaultMessage: 'Ethics & Compliance',
  },
});

// {default: 'https://support.stubhub.com', 1.fr-CA: 'https://stubhub-cafr.custhelp.com', 2: 'https://stubhub-uk.custhelp.com', 3: 'https://stubhub-dede.custhelp.com', 4: 'https://stubhub-frfr.custhelp.com', 5: 'https://stubhub-mxes.custhelp.com', 6: 'https://stubhub-eses.custhelp.com', 7: 'https://stubhub-ptpt.custhelp.com', 8: 'https://support.stubhub.com', 9: 'https://stubhub-czcs.custhelp.com', 10: 'https://stubhub-it.custhelp.com', 11: 'https://stubhub-nlnl.custhelp.com', 12: 'https://stubhub-atde.custhelp.com', 13: 'https://stubhub-benl.custhelp.com', 14: 'https://stubhub-uk.custhelp.com', 15:	'https://stubhub-fifi.custhelp.com', 16: 'https://stubhub-lu-fr.custhelp.com', 17: 'https://stubhub-elen.custhelp.com', 18: 'https://stubhub-plpl.custhelp.com', 19: 'https://stubhub-sesv.custhelp.com', 20: 'https://stubhub-dken.custhelp.com'},
export const FooterLinks = (storeId, locale) => {
  let navLinks;
  if (locale) {
    try {
      navLinks = require(`../config/nav-links.config.${storeId}.${locale}.json`);
    } catch (e) {
      try {
        navLinks = require('../config/nav-links.config.json');
      } catch (e) {
        // Ignore
      }
    }
  }
  const links = {
    'about-us': '/about-us/',
    help: navLinks,
    'contact-us': '/contact-us/',
    developers: 'https://developer.stubhub.co.uk/',
    careers: '/jobs/',
    legal: '/legal/',
    partners: '/partners/',
    advantage: '/promise/',
    notifications: '/notifications/',
    'events-by-venue': navLinks && navLinks['events-by-venue'] && navLinks['events-by-venue'].href,
    affiliates: navLinks && navLinks.affiliates && navLinks.affiliates.href,
    impressum: '/about-us/?section=culture',
    restrictions: '/restrictions/',
    'ethics-compliance': '/aviso/',
  };

  return links;
};

const FooterColumns = defineMessages({
  'about-stubhub': {
    id: 'Footer.linkTitle.ourCompany',
    defaultMessage: 'Our Company',
  },
  'fan-hub': {
    id: 'Footer.linkTitle.questions',
    defaultMessage: 'Have Questions?',
  },
});

const SiteConfigs = {
  defaults: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners', 'developers']},
    {title: 'fan-hub', items: ['help', 'events-by-venue', 'contact-us']},
  ],
  1: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'partners', 'developers', 'careers']},
    {title: 'fan-hub', items: ['help', 'events-by-venue', 'contact-us']},
  ],
  2: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help']},
  ],
  3: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'legal', 'impressum', 'partners']},
    {title: 'fan-hub', items: ['help']},
  ],
  4: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help']},
  ],
  5: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'notifications']},
  ],
  6: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'ethics-compliance', 'events-by-venue']},
  ],
  7: [
    {title: 'about-stubhub', items: ['help', 'affiliates', 'about-us', 'careers', 'partners']},
    {title: 'fan-hub', items: ['notifications']},
  ],
  8: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'developers', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'events-by-venue']},
  ],
  10: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help']},
  ],
  14: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners', 'help']},
    {title: 'fan-hub', items: ['notifications']},
  ],
  16: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners', 'help']},
    {title: 'fan-hub', items: ['notifications']},
  ],
  19: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners', 'help']},
    {title: 'fan-hub', items: ['notifications']},
  ],
  22: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'notifications', 'events-by-venue', 'restrictions']},
  ],
  23: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'notifications', 'events-by-venue']},
  ],
  24: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'notifications', 'events-by-venue']},
  ],
  26: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'notifications', 'events-by-venue']},
  ],
  27: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'notifications', 'events-by-venue']},
  ],
  28: [
    {title: 'about-stubhub', items: ['about-us', 'affiliates', 'careers', 'partners']},
    {title: 'fan-hub', items: ['help', 'notifications', 'events-by-venue']},
  ],
};

/**
 * Get footer link configs by store id
 * @param {number} storeId
 */
export const getFooterData = (storeId, locale) => {
  const config = SiteConfigs[storeId] || SiteConfigs.defaults;
  const data = config.map((columnConfig) => {
    const column = {
      id: columnConfig.title,
      message: FooterColumns[columnConfig.title],
    };
    column.items = columnConfig.items.map((linkKey) => {
      let href = FooterLinks(storeId, locale)[linkKey];
      // Cannot reach line with current configs
      /* istanbul ignore next */
      if (!href) {
        throw `Missing href config for footer link ${linkKey}`;
      }
      if (typeof href !== 'string') {
        href = href[parseInt(storeId)] || href.default || href;
      }

      const message = FooterLinkMessages[linkKey];

      return {id: linkKey, href, message};
    });

    return column;
  });

  return data;
};
